import { render, staticRenderFns } from "./CMSEmailFormForm.vue?vue&type=template&id=ded4cf7a&"
import script from "./CMSEmailFormForm.vue?vue&type=script&lang=js&"
export * from "./CMSEmailFormForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports